import React from 'react';
import { Typography } from '@mui/material';
import useFieldHelper from '../fieldHelper';
import { FieldProps } from '../types';

const VersionField = ({ source }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const policyVersion = getValue();

  return <Typography>v.{policyVersion}</Typography>;
};

export default VersionField;
